import React from "react";
import Container from "@mui/material/Container";
import { makeStyles } from "tss-react/mui";

import logoText from "../../images/logoText_kemaro.png";
import CustomSnackbar from "./CustomSnackbar";

const useStyles = makeStyles()(() => ({
    loadingErrorImage: { width: "100%" },
}));

const ErrorPageWithSnackbar: React.FC<{
    errorTitle: string;
    errorMessages?: string[] | null;
}> = (props) => {
    const { classes } = useStyles();

    return (
        <Container>
            <img src={logoText} alt={props.errorTitle} className={classes.loadingErrorImage} />
            <CustomSnackbar
                title={props.errorTitle}
                textMessages={props.errorMessages ?? undefined}
                open={true}
                severity="error"
                onClose={() => {}}
            />
        </Container>
    );
};

export default ErrorPageWithSnackbar;
